import React from 'react';

const DislikeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33.566" height="33.566" viewBox="0 0 33.566 33.566">
      <g>
        <path fill={'currentColor'} d="M19.031 4.517v14.21a2.827 2.827 0 0 1-.476 1.566l-3.818 5.678a2.988 2.988 0 0 1-5.357-2.294l.727-4.573a1.4 1.4 0 0 0-.294-1.091 1.3 1.3 0 0 0-.965-.434H3.1A3.132 3.132 0 0 1 .485 16.35a2.946 2.946 0 0 1-.28-2.727L3.646 3.147A4.493 4.493 0 0 1 7.842 0H13.3a4.559 4.559 0 0 1 2.85.923l1.79 1.385a2.8 2.8 0 0 1 1.091 2.209z" transform="translate(2.801 3.175)"/>
        <path fill={'currentColor'} d="M3.049 19.874h1.44c2.168 0 3.049-.839 3.049-2.909V2.909C7.538.839 6.657 0 4.489 0h-1.44C.881 0 0 .839 0 2.909v14.07c0 2.056.881 2.895 3.049 2.895z" transform="translate(23.231 4.755)"/>
      </g>
    </svg>
  );
};

export default DislikeIcon;
